(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dracarrj-crown-rewards-smile"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function(event) {
    var trigger = event.target.closest('[data-drx-smile-open]');
    if (!trigger) return;
    var candidates = [
      '.smile-launcher-frame-container',
      '.smile-launcher',
      '[data-smile-launcher]',
      'button[aria-label*="rewards" i]',
      'button[aria-label*="smile" i]'
    ];
    for (var i = 0; i < candidates.length; i += 1) {
      var launcher = document.querySelector(candidates[i]);
      if (launcher) {
        launcher.click();
        return;
      }
    }
    window.location.href = '/pages/crown-rewards';
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
